<template>
    <div id="page-container">
        <Menu />
        <router-view></router-view>
        <!--<LiveChat v-on:toggle-body-overflow="toggleBodyOverflow" />-->
        <Footer />
    </div>
</template>

<script>
    import Home from './views/Home'
    import Menu from "./components/MainMenu";
    import LiveChat from "./components/LiveChat";
    import Footer from "./components/Footer";

    export default {
        components: {Footer, LiveChat, Menu, Home},
        methods: {
            toggleBodyOverflow(hideOverflow) {
                let bodyTag = document.getElementsByTagName('body')[0];
                if(hideOverflow === true) {
                    bodyTag.classList.add('hide-body-overflow');
                } else {
                    bodyTag.classList.remove('hide-body-overflow');
                }
            }
        }
    }


</script>

<style>
    html {
        font-size: 16px;
    }
    body {
        font-family: 'Montserrat', sans-serif;
        margin: 0;
        background-color: #F1DDC4;
    }

    #page-container {
        width: 100%;
        max-width: 1440px;
        margin: 0 auto;
        box-shadow: 0 5px 10px #666;
    }

    .generic-wrapper {
        margin-top: 101px;
        background-color: #FFF;
        padding: 1px 20px 50px 20px;
    }

    label {
        font-weight: 500;
        font-size: 1.1rem;
    }

    input, select {
        padding: 10px;
        font-size: 1rem;
        width: 100%;
        box-sizing: border-box;
    }

    input {
        border: 1px solid #F1DDC4;
    }

    .page-title {
        text-align: center;
        font-weight: 600;
        margin: 40px 0;
        color: #643229;
    }

    .page-subtitle {
        text-align: center;
        margin: 20px 0;
        color: #643229;
    }

    .body-text {
        text-align: justify;
        font-size: 1.1rem;
        margin: 8px 0;
    }

    h1 {
        font-size: 1.875rem;
    }
    h2 {
        font-size: 1.625rem;
    }

    h3 {
        font-size: 1.25rem;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        html {
            font-size: 14px;
        }
        .hide-body-overflow {
            overflow: hidden;
        }

        .generic-wrapper {
            margin-top: 92px;
        }
    }

</style>
